import { Box, Grid, Tooltip, Typography } from '@mui/material'
import React from 'react'
import CheckIcon from "@mui/icons-material/Check";

interface TeamNotificationStatusProps {
  statusData: {
    Id: number | null,
    Team: string,
    IsSent: boolean
  }[]
}

const TeamNotificationStatus: React.FC<TeamNotificationStatusProps> = ({ statusData }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ borderRadius: 2 }}
    >

      <Grid container spacing={1} justifyContent="center">
        {statusData.map((t, idx) => (
          <Tooltip
            title={
              t.IsSent
                ? `Notification sent to ${t.Team}`
                : `Notification not yet sent to ${t.Team}`
            }
            slotProps={{
              popper: {
                sx: {
                  "& .MuiTooltip-tooltip": {
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "0.75rem",
                    border: "1px solid #ccc",
                  },
                },
              },
            }}
          >
            <Grid item key={idx} xs={2.5} textAlign="center">
              <Typography
                variant="caption"
                sx={{ mb: 1, fontWeight: 500, color: "#333" }}
              >
                {t.Team}
              </Typography>
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  borderRadius: "50%",
                  bgcolor: t.IsSent ? "#ECFDF3" : "#FEF3F2",
                  border: t.IsSent ? "1px solid #47CD89" : "1px solid #FECDCA",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mx: "auto",
                }}
              >
                {t.IsSent && (
                  <CheckIcon sx={{ color: "#067647", fontSize: 12 }} />
                )}
              </Box>
            </Grid>
          </Tooltip>
        ))}
      </Grid>
    </Box>
  )
}

export default TeamNotificationStatus
